import { FetchContext } from '../fetch-context';
import { UploadedMedia } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getUploadedMedia: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<UploadedMedia[]> = (fetchContext, awardId, nominationId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/uploaded-media`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<UploadedMedia[]>(fetchContext.errorStore, response, 'get uploaded media'));
